import { defineQuery } from '@pinia/colada'
import { STALE_TIME } from '@rialtic/utils'

const CONFIG_QUERY_KEYS = {
  root: ['config'] as const,
}

export const useApiConfig = defineQuery({
  key: CONFIG_QUERY_KEYS.root,
  query: () => {
    const client = useRequestFetch()
    return client<{
      sessionId: string | null
      analyticsEngineAvailable: boolean
    }>('/api/config')
  },
  staleTime: STALE_TIME.ONE_HOUR,
})
